<template>
    <div class="welcome-screen">
        <div
            class="pharmacy-exterior"
            :class="{ 'zoom-in': isZooming }"
        >
            <img
                src="/apo-draussen.png"
                alt="Apotheke"
                class="background-image"
            />

            <img
                src="/glas-left.png"
                alt="Glas Links"
                class="glass-panel glass-left"
            />
            <img
                src="/glas-right.png"
                alt="Glas Rechts"
                class="glass-panel glass-right"
            />

            <div class="doors-container">
                <img
                    src="/tuer-left.png"
                    alt="Tür Links"
                    class="door door-left"
                    :class="{ 'open-left': doorsOpen }"
                />
                <img
                    src="/tuer-right.png"
                    alt="Tür Rechts"
                    class="door door-right"
                    :class="{ 'open-right': doorsOpen }"
                />
            </div>

            <div
                class="content-box"
                :class="{ 'fade-out': contentHidden }"
            >
                <img
                    src="/regal-champion-logo.png"
                    alt="Regal Champion"
                    class="regal-champion-logo"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, onMounted } from 'vue';

    const emit = defineEmits<{
        complete: [];
    }>();

    const doorsOpen = ref(false);
    const isZooming = ref(false);
    const contentHidden = ref(false);

    onMounted(() => {
        startAnimation();
    });

    const startAnimation = () => {
        setTimeout(() => {
            contentHidden.value = true;
        }, 1500);

        setTimeout(() => {
            doorsOpen.value = true;
        }, 2500);

        setTimeout(() => {
            isZooming.value = true;
        }, 4000);

        setTimeout(() => {
            emit('complete');
        }, 5000);
    };
</script>

<style scoped>
    /* WelcomeScreen.vue */
    .welcome-screen {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 30;
        overflow: hidden;
    }

    .welcome-screen .pharmacy-exterior {
        position: relative;
        width: 100%;
        height: 100%;
        transition: transform 1s ease-out;
    }

    .welcome-screen .pharmacy-exterior.zoom-in {
        transform: scale(1.5);
    }

    .welcome-screen .background-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center center;
    }

    .welcome-screen .glass-panel {
        position: absolute;
        top: 28.4%;
        height: 39%;
        width: auto;
        object-fit: contain;
        z-index: 5;
    }

    .welcome-screen .glass-left {
        left: 1.2%;
    }

    .welcome-screen .glass-right {
        right: 1.2%;
    }

    .welcome-screen .doors-container {
        position: absolute;
        top: 28.2%;
        left: 32.1%;
        width: 35.9%;
        height: 39.5%;
        pointer-events: none;
        z-index: 10;
    }

    .welcome-screen .door {
        position: absolute;
        top: 0;
        height: 100%;
        width: auto;
        object-fit: contain;
        transition: transform 1.5s ease-out;
    }

    .welcome-screen .door-left {
        left: 0;
    }

    .welcome-screen .door-left.open-left {
        transform: translateX(-100%);
    }

    .welcome-screen .door-right {
        right: 0;
    }

    .welcome-screen .door-right.open-right {
        transform: translateX(100%);
    }

    .welcome-screen .content-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 20;
        background: rgba(255, 152, 0, 0.9);
        border-radius: 16px;
        padding: 65px 45px;
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.26);
        backdrop-filter: blur(10px);
        border: 2px solid rgba(255, 152, 0, 0.8);
        cursor: pointer;
        transition:
            opacity 0.5s ease-out,
            transform 0.5s ease-out;
        text-align: center;
        max-width: 85%;
        min-width: 63%;
    }

    .welcome-screen .content-box.fade-out {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.9);
        pointer-events: none;
    }

    .welcome-screen .regal-champion-logo {
        width: 100%;
        max-width: 400px;
        height: auto;
        display: block;
        margin: 0 auto;
        filter: drop-shadow(3px 3px 6px rgba(0, 0, 0, 0.2));
    }
</style>
